<style>
 /* Styles */
</style>

<template>
    <v-app>
      <v-navigation-drawer app v-model="drawer" disable-resize-watcher="true" temporary="true" hide-overlay width="200" v-if="$auth.user()">
        <v-toolbar flat class="transparent">
          <v-list class="pa-0">
            <v-list-tile avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{ $auth.user().displayName || $auth.user().email }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-toolbar>
        <v-list>
          <v-list-tile @click="$router.push('/projects-list')">
            <v-list-tile-content>
              <v-list-tile-title>Проекты</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile @click="$router.push('/account')">
            <v-list-tile-content>
              <v-list-tile-title>Лицевой счет</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile @click="$router.push('/update-profile')">
            <v-list-tile-content>
              <v-list-tile-title>Профиль</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="$router.push('/faq')">
            <v-list-tile-content>
              <v-list-tile-title>Вопросы и ответы</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile @click="logout()">
            <v-list-tile-content>
              <v-list-tile-title>Выйти</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-navigation-drawer>
      <v-toolbar app >
        <v-toolbar-side-icon @click.native="drawer = !drawer" v-if="$auth.user()"></v-toolbar-side-icon>
        <v-toolbar-title>Fuelcrowd</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <!--<v-btn flat @click="RoutesUtils.docs()">Docs</v-btn> -->
          <v-btn flat v-if="$auth.user()" @click="logout()">Выйти</v-btn>
          <v-btn flat v-else @click="login()">Войти</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-content>
        <v-container>
          <router-view></router-view>
        </v-container>
      </v-content>
      <v-footer app>
        <span class="text-center">FuelCrowd &copy; 2019</span>
        <v-spacer></v-spacer>
      </v-footer>
    </v-app>
</template>
<script>
import RoutesUtils from '@/router/utils'

export default {
  mounted () {
    this.$auth
      .check()
      .then(user => {
        console.log('Layout mounted',user.email);

      })
      .catch(err => {})
  },
  data () {
    return {
      drawer: false,
      RoutesUtils: RoutesUtils.navigation
    }
  },
  methods: {
    logout () {
      this.$auth.logout().then(() => {
        this.$router.push('/login')
      })
    },
    login () {
      this.$router.push('/login')
    }
  },
}
</script>



// WEBPACK FOOTER //
// Layout.vue?6cfe6d56